import { useEffect } from 'react'

import { useLocalStorage } from '@buffer-mono/popcorn'

import { useAccountPreferences } from '~publish/contexts/AccountContext'

type WeekStartsOn = 'monday' | 'sunday'

const WEEK_START_LOCAL_STORAGE_KEY = 'week-starts-on'
const DEFAULT_WEEK_START: WeekStartsOn = 'monday'

function parseWeekStartsOn(value: unknown): WeekStartsOn {
  return value === 'sunday' ? 'sunday' : DEFAULT_WEEK_START
}

// The account query exposes `startOfWeek` as a nullable `String`, so the two
// supported values are represented directly here; the `StartOfWeek` schema enum
// is scoped to the update-preference mutation, not this read path.
export const useWeekStartsOn = (): WeekStartsOn => {
  const preferences = useAccountPreferences()
  const [cachedWeekStartsOn, setCachedWeekStartsOn] =
    useLocalStorage<WeekStartsOn>(
      WEEK_START_LOCAL_STORAGE_KEY,
      DEFAULT_WEEK_START,
    )
  const remoteWeekStartsOn = preferences
    ? parseWeekStartsOn(preferences.startOfWeek)
    : null

  useEffect(() => {
    if (remoteWeekStartsOn) {
      setCachedWeekStartsOn(remoteWeekStartsOn)
    }
  }, [remoteWeekStartsOn, setCachedWeekStartsOn])

  return remoteWeekStartsOn ?? parseWeekStartsOn(cachedWeekStartsOn)
}
